import axios from "axios"
import store from "@/store/index"

const host = process.env.VUE_APP_IMS_BASE_URL
export const baseURL = `${host}/api/v1`

const apiIms = axios.create({
  baseURL,
})

apiIms.interceptors.request.use(
  (config) => {
    const authStore = store.state.authStore

    if (authStore.isAuthenticated && authStore.user.access_token) {
      config.headers.Authorization = `Bearer ${authStore.user.access_token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default apiIms
